import React, { Fragment } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { ContentNav } from '../_common';
import AppealForm from './AppealForm';
import AppealAskQuestion from './AppealForm/AppealAskQuestion';
import Appeals from './TypeAppeals/Appeals/Appeals';
import AppealsQuestion from './TypeAppeals/AppealsQuestion/AppealsQuestion';
import Documents from './Documents/Document';

export default function Feedback() {
 const feature = useQueryClient().getQueryData<Models.Feature>('feature');

 return (
  <>
   <ContentNav
    links={[
     {
      name: 'Обращения',
      path: '/feedback/appeals',
      exact: true,
      featured: Number(feature?.officialAppeals || feature?.aisAppeals),
     },
     //  {
     //   name: 'Вопросы',
     //   path: '/feedback/appeals-question',
     //  },

     /**
      * согласно ЗНР-С-ЛКЮЛ-00000000001440 скрыл от пользователя
      */
     //  {
     //   name: 'Создать обращение',
     //   path: '/feedback/appeal-create',
     //  },
     //  {
     //   name: 'Задать вопрос',
     //   path: '/feedback/appeal-create-question',
     //  },
     {
      name: 'Документы на заключение/перезаключение договора',
      path: '/feedback/documents',
     },
    ]}
   />
   <Switch>
    <Route path="/feedback/appeals" component={Appeals} />
    <Route path="/feedback/appeals-question" component={AppealsQuestion} />
    <Route path="/feedback/appeal-create" component={AppealForm} />
    <Route path="/feedback/documents" component={Documents} />
    <Route
     path="/feedback/appeal-create-question"
     component={AppealAskQuestion}
    />
    <Route render={() => <Redirect to="/feedback/appeals" />} />
   </Switch>
  </>
 );
}
